

































































import { Component, Prop, Vue } from "vue-property-decorator";
import SideComponent from "./SideComponent.vue";
import { Cube, Cell, Side } from "@/models";
import { Direction } from "@/enums";

@Component({
  components: {
    SideComponent
  }
})
export default class CubeComponent extends Vue {
  @Prop() private rotateX!: number;
  @Prop() private rotateY!: number;
  public get cube(): Cube {
    return this.$store.state.cube;
  }

  move(cell: Cell, direction: Direction, side: Side) {
    this.$store.commit("move", {
      cell: cell,
      direction: direction,
      side: side
    });
  }
}
